export class APITools {

    static sleep(ms) {
        return new Promise(r => setTimeout(_ => r(), ms));
    }

}
